<template>
  <!-- 虚拟号管理 -->
  <div class="Customer">
    <el-card>
      <el-table :data="tableData" style="width: 100%" border size="mini">
        <el-table-column label="虚拟号码" prop="VirtualNum"> </el-table-column>
        <el-table-column label="通话时长" prop="longTime"> </el-table-column>
        <el-table-column label="通话费用" prop="cost"></el-table-column>
        <!-- <el-table-column label="月租费用"> </el-table-column> -->
        <el-table-column label="绑定号码" prop="bdphone">
          <template slot-scope="scope">
            {{ scope.row.bdphone || "未绑定" }}
          </template>
        </el-table-column>
        <el-table-column label="绑定员工" prop="bdname"> </el-table-column>
        <el-table-column label="导入时间" prop="CreatedDate"> </el-table-column>
        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="(dialogVisible = true), (dialogVisible1Obj = scope.row)"
              v-if="scope.row.bdphone"
              >解绑</el-button
            >
            <el-button
              type="text"
              style="color: red;"
              v-else
              @click="(dialogVisible2 = true), (dialogVisible2Obj = scope.row)"
              >释放</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-dialog
      :visible.sync="dialogVisible"
      width="50%"
      center
      :before-close="handleClose"
    >
      <h4 class="textalign">当前绑定账户</h4>
      <h3 class="textalign">
        {{ dialogVisible1Obj.bdname }} {{ dialogVisible1Obj.bdact }}
        {{ dialogVisible1Obj.bdphone }}
      </h3>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
        <el-button type="primary" size="mini" @click="handelFun('1')"
          >确定解绑</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogVisible2"
      width="50%"
      center
      :before-close="handleClose"
    >
      <h3 class="textalign">确认释放 {{ dialogVisible2Obj.VirtualNum }}</h3>
      <div class="durk">
        <p>1.释放号码后，该号码将从系统内永久消失。</p>
        <p>2.下个自然月开始将不会扣取月租费，当月月租费用正常扣取。</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false" size="mini">取 消</el-button>
        <el-button type="primary" size="mini" @click="handelFun('2')"
          >确定释放</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      dialogVisible2: false,
      tableData: [],
      dialogVisible2Obj: {}, //释放
      dialogVisible1Obj: {} //解绑
    };
  },
  methods: {
    handleClose(e) {
      e();
    },
    handelFun(type) {
      switch (type) {
        case "1":
          // 1 解绑
          console.log(this.dialogVisible1Obj);
          this.getUnbundling(
            this.dialogVisible1Obj.VirtualNum,
            this.dialogVisible1Obj.sub_id
          );
          break;

        case "2":
          // 2  释放
          console.log(this.dialogVisible2Obj);
          this.getRelease(this.dialogVisible2Obj.ID);
          break;

        default:
          break;
      }
    },
    // 获取时长
    GetTimeLong(time) {
      let timer = time * 1000;
      let hh = Math.floor(timer / 1000 / 60 / 60);
      let mm = Math.floor((timer - hh * 3600 * 1000) / 60 / 1000);
      let ss = Math.floor((timer - (hh * 24 + mm) * 60 * 1000) / 1000);
      return {
        hh,
        mm,
        ss
      };
    },

    // 获取数据
    getDataList() {
      console.log("我执行了");
      let formdata = new FormData();
      formdata.append("action", "getVirtualNumlist");
      formdata.append("pageno", "");
      formdata.append("pagesize", "10");
      this.$axios
        .formatPostData("manage/SetInData.aspx", formdata)
        .then(res => {
          console.log(res);
          if (res.data.errcode == 0) {
            res.data.list.forEach(element => {
              let timer = this.GetTimeLong(element.calllongtime);
              element.longTime = `${timer.hh}:${timer.mm}:${timer.ss}`;
            });
            this.tableData = res.data.list;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    // 解绑
    getUnbundling(VirtualNum, sub_id) {
      console.log("我执行了");
      let formdata = new FormData();
      formdata.append("action", "UnbindVirtualNum");
      formdata.append("VirtualNum", VirtualNum);
      formdata.append("sub_id", sub_id);
      this.$axios
        .formatPostData("manage/SetInData.aspx", formdata)
        .then(res => {
          console.log(res);
          if (res.data.errcode == 0) {
            // this.tableData = res.data.list;
            this.$message({
              message: "操作",
              type: "success"
            });
            this.getDataList();
            this.dialogVisible1 = false;
          } else {
            this.dialogVisible1 = false;
            this.$message.error(res.data.msg);
          }
        })
        .catch(err => {
          this.dialogVisible1 = false;
        });
    },
    // 释放
    getRelease(ID) {
      console.log("我执行了");
      let formdata = new FormData();
      formdata.append("action", "DelVirtualNum");
      formdata.append("ID", ID);
      this.$axios
        .formatPostData("manage/SetInData.aspx", formdata)
        .then(res => {
          console.log(res);
          if (res.data.errcode == 0) {
            // this.tableData = res.data.list;
            this.$message({
              message: "操作",
              type: "success"
            });
            this.getDataList();
            this.dialogVisible2 = false;
          } else {
            this.$message.error(res.data.msg);
            this.dialogVisible2 = false;
          }
        })
        .catch(err => {
          this.dialogVisible2 = false;
        });
    }
  },
  mounted() {
    this.getDataList();
  },
  created() {}
};
</script>

<style scoped>
.textalign {
  text-align: center;
  color: #5e5e5e;
}
.durk {
  background-color: #f1f1f1;
  box-sizing: border-box;
  padding: 10px;
}
</style>
